// @flow
import $ from 'jquery';

const PLUGIN_NAME = 'fgAnalytics';
const DEBUG = false;

const fragments = {
	PRICE: '[data-fragment="Payment.price"]',
};

const leadingZero = number => (number.toString().length === 1) ? `0${ number }` : `${ number }`;

const getPageName = () => {
	const _pnE = (document.getElementsByTagName('h1').length > 0)
		? document.getElementsByTagName('h1')
		: document.getElementsByTagName('title');
	const text = _pnE[ 0 ].innerText;
	return (text) ? text.trim() : '';
};

const getLandingPageName = () => {
	const classes = document.body && document.body.classList;
	if ( classes && classes.contains('js_gtmPageMortgage') ) {
		return 'LP Mám hypotéku';
	}
	if ( classes && classes.contains('js_gtmPageFamily') ) {
		return 'LP Zajištění rodiny';
	}

	return '';
};

/**
 * Converts dates from multiple formats into DD.MM.YYYY
 *
 * - input format A (data-rest)         - YYYY-M-D
 * - input format B (mobile datepicker) - YYYY-MM-DD
 * - input format C (pure desktop)      - D. M. YYYY
 * - input format D (full JS date)      - EEE d MMM yyyy HH:mm:ss Z
 *
 * note: method cannot handle input format MM-DD-YYYY !
 *
 * @param date
 * @return {string}
 */
const makeDate = (date) => {
	let dateObj;
	let year;
	let month;
	let day;
	if ( / GMT[\\+-]\d/.test(date) ) {
		dateObj = new Date(date);
	} else if ( /\d{1,2}\.\s*\d{1,2}\.\s*\d{4}/.test(date) ) {
		const parts = date.split(/[. ] */);
		if ( typeof parseInt(parts[ 0 ]) === 'number' &&
			typeof parseInt(parts[ 1 ]) === 'number' &&
			typeof parseInt(parts[ 2 ]) === 'number' ) {
			[ day, month, year ] = parts;
			dateObj = new Date(year, (month - 1), day);
		}
	} else if ( /\d{1,2}-\d{1,2}-\d{4}/.test(date) ) {
		const parts = date.split('-');
		if ( typeof parseInt(parts[ 0 ]) === 'number' &&
			typeof parseInt(parts[ 1 ]) === 'number' &&
			typeof parseInt(parts[ 2 ]) === 'number' ) {
			[ day, month, year ] = parts;
			dateObj = new Date(year, (month - 1), day);
		}
	} else if ( /\d{4}-\d{1,2}-\d{1,2}/.test(date) ) {
		const parts = date.split('-');
		if ( typeof parseInt(parts[ 0 ]) === 'number' &&
			typeof parseInt(parts[ 1 ]) === 'number' &&
			typeof parseInt(parts[ 2 ]) === 'number' ) {
			[ year, month, day ] = parts;
			dateObj = new Date(year, (month - 1), day);
		}
	}

	if ( !(dateObj instanceof Date) ) return 'Invalid date';

	return `${ leadingZero(dateObj.getDate()) }.${ leadingZero(dateObj.getMonth() + 1) }.${ dateObj.getFullYear() }`;
};

// simple logger
function clog(...args: any): void {
	if ( window.console && DEBUG ) {
		/* eslint-disable no-alert, no-console */
		console.group(`Debug of ${ PLUGIN_NAME }`);
		Object.values(args).forEach(value => console.log(value));
		console.groupEnd();
		/* eslint-enable no-alert, no-console */
	}
}

const dlPush = (data) => {

	let partner = '';
	if ( document.body && document.body.dataset && document.body.dataset.actionPartner ) {
		partner = document.body.dataset.actionPartner;
		partner = partner.charAt(0).toUpperCase() + partner.slice(1);
	}
	const pushData = data;
	const category = `${ data.fgVarCat || '' }`;
	if ( partner && category && pushData.fgVarCat ) {
		pushData.fgVarCat += ` - ${ partner }`;
	}
	if ( DEBUG ) {
		clog(pushData);
	} else {
		window.dataLayer.push(pushData);
	}
};

/*
	// todo - proper tests needed!
	// @test makeDate(date)
	$(window).on('load', ()=>{
		const dates = [
			['19.03.1987' , '1987-3-19'],
			['19.03.1987' , '19.3.1987'],
			['19.03.1987' , '19. 3. 1987'],
			['19.03.1987' , '19. 03. 1987'],
			['19.03.1987' , '19-3-1987'],
			['19.03.1987' , '19-03-1987'],
			['19.03.1987' , '1987-03-19'],
			['invalid'    , '1987-19'],
			['invalid'    , '3-19'],
			['invalid'    , '3-19-1987'],
			['09.12.1987' , '1987-12-9'],
			['09.12.1987' , '9.12.1987'],
			['09.12.1987' , '9. 12. 1987'],
			['09.12.1987' , '09. 12. 1987'],
			['09.12.1987' , '09-12-1987'],
			['09.12.1987' , '9-12-1987'],
			['09.12.1987' , '1987-12-09'],
		];
		dates.forEach( value => {
			const ref = value[0];
			const uut;
			try {
				uut = makeDate( value[1] )
			} catch (e) {
				uut = 'invalid';
			}
			console.log(`testing: ${ref} vs. ${uut}`);
			if( !!(uut === ref) ) {
				console.info('%cpassed', 'color:white;background:green');
			} else {
				console.warn('%cfailed', 'color:white;background:red;font-weight:bold;');
			}
		})
	});
*/

/**
 * Mereni webu
 */

// GA eventy
$(document).on('click', '.buttons-snippet button[type="submit"], .buttons-snippet a.btn', function () {
	const formTitle = $(this).parents('.item').data('title') || getPageName();
	const buttonTitle = $(this).text();

	dlPush({
		'event':     'fgWebAnalytics',
		'fgVarType': 'Formuláře',
		'fgVarCat':  formTitle,
		'fgVarAct':  buttonTitle, // buď 'Spočítat pojištění ', nebo ' Sjednat schůzku '
		'fgVarLbl':  buttonTitle, // buď 'Spočítat pojištění ', nebo ' Sjednat schůzku '
		'fgVarTxt':  '',
	});
});

// GA - submit contact formu
$(document).on('submit', '#weWillCallYouForm', function () {
	const phoneNumber = $('#phone', this).val();

	dlPush({
		'event':     'fgWebAnalytics',
		'fgVarType': '',
		'fgVarCat':  'Lead',
		'fgVarAct':  'Zavolejte mi',
		'fgVarLbl':  phoneNumber,
		'fgVarTxt':  '',
	});
});

$(window).on('beforeContentsReplaced', (e) => {
	try {
		if ( e.detail.settings.eventName === 'eventName.subscribeMe:subscribeMe' ) {
			// clog(e);
			// GA - submit newsletter formu
			const addr = document.getElementById('address');
			if ( addr instanceof HTMLInputElement ) {
				dlPush({
					'event':     'fgWebAnalytics',
					'fgVarType': '',
					'fgVarCat':  'Lead',
					'fgVarAct':  'Přihlášení newsletteru',
					'fgVarLbl':  addr.value,
					'fgVarTxt':  '',
				});
			}
			// AdForm - prihlaseni k newsletteru
			dlPush({
				'event': 'fgAdformNewsletter',
			});
		}
	} catch ( e ) {
		// PU event wasnt submit??
		console.error(e);
	}
});

// GA - click na sociální ikonky
$(document).on('click', '.social-media li a', function () {
	const label = $('span.sr-only', this).text();

	dlPush({
		'event':     'fgWebAnalytics',
		'fgVarType': '',
		'fgVarCat':  'Odchozí weby',
		'fgVarAct':  'Sociální sítě',
		'fgVarLbl':  label, // 'Facebook', 'Youtube', 'Linkedin'
		'fgVarTxt':  '',
	});
});

// GA - click na buttony v hlavičce
$(document).on('click', '.header-content .button-links li a', function () {
	const label = $(this).text();

	dlPush({
		'event':     'fgWebAnalytics',
		'fgVarType': '',
		'fgVarCat':  'Interakce',
		'fgVarAct':  'Horní menu',
		'fgVarLbl':  label,
		'fgVarTxt':  '',
	});
});

// GA - odeslání formulářů - Sjednat schůzku
$(document).on('submit', '#meetingForm', () => {

	dlPush({
		'event':     'fgWebAnalytics',
		'fgVarType': '',
		'fgVarCat':  'Kontaktní formuláře',
		'fgVarAct':  'Sjednat schůzku', // Poslat dotaz / Sjednat schůzku / Vaše podněty a připomínky
		'fgVarLbl':  '/cs/kontakty/sjednat-schuzku', // komplet cesta bez domény
		'fgVarTxt':  '',
	});
});

// GA - odeslání formulářů - Sjednat schůzku
$(window).on('partialUpdateComplete', (e) => {
	// clog(e);
	try {
		if ( e.detail.settings.submitId === 'meetingForm' && document.querySelectorAll('#resultText').length > 0 ) {
			// GA - odeslání formulářů - Sjednat schůzku
			dlPush({
				'event':    'fgWebAnalytics',
				'fgVarCat': 'Kontaktní formuláře',
				'fgVarAct': 'Sjednat schůzku - tlačítko Kontaktujte mě',
				'fgVarLbl': window.location.pathname,
			});
		}
	} catch ( e ) {
		// PU event wasnt submit??
		console.error(e);
	}
});

// GA - odeslání formulářů - Poslat dotaz
$(window).on('partialUpdateComplete', (e) => {
	try {
		if ( e.detail.settings.submitId === 'sendQueryForm' && document.querySelectorAll('#resultText').length > 0 ) {
			dlPush({
				'event':     'fgWebAnalytics',
				'fgVarType': '',
				'fgVarCat':  'Kontaktní formuláře',
				'fgVarAct':  'Poslat dotaz', // Poslat dotaz / Sjednat schůzku / Vaše podněty a připomínky
				'fgVarLbl':  '/cs/kontakty/poslat-dotaz', // komplet cesta bez domény
				'fgVarTxt':  '',
			});
		}
	} catch ( e ) {
		// PU event wasnt submit??
		console.error(e);
	}
});

// GA - odeslání formulářů - Vaše podněty a připomínky
$(document).on('submit', '#commentsForm', () => {

	dlPush({
		'event':     'fgWebAnalytics',
		'fgVarType': '',
		'fgVarCat':  'Kontaktní formuláře',
		'fgVarAct':  'Vaše podněty a připomínky', // Poslat dotaz / Sjednat schůzku / Vaše podněty a připomínky
		'fgVarLbl':  '/cs/kontakty/vase-podnety-a-pripominky', // komplet cesta bez domény
		'fgVarTxt':  '',
	});
});

// GA - odeslání formulářů - Kontakt z kalkulacky
// partialUpdate požere `click` i `submit` události, nelze se na ně chytnout
// zrušení PU vede k jiným chybám
$(document).on('afterContentsReplaced', (e) => {
	if ( $(e.target).find('.js_gtmCalculatorContact').parents('form').length > 0 ) {
		dlPush({
			'event':     'fgWebAnalytics',
			'fgVarType': '',
			'fgVarCat':  'Kontaktní formuláře',
			'fgVarAct':  `Sjednat schůzku - kalkulačka ${ getPageName() }`, // Poslat dotaz / Sjednat schůzku / Vaše podněty a připomínky
			'fgVarLbl':  window.location.pathname, // komplet cesta bez domény
			'fgVarTxt':  '',
		});
	}
});

// GA - přepnutí záložky
$(document).on('click', '.transformer-tabs .tabs a, .transformer-tabs .tabs a svg', (e) => {
	// console.log('click on tabs link');
	const text = e.target.closest('a').textContent.trim();
	const pageName = (document.body && document.body.classList.contains('hp')) ? 'HP' : (getLandingPageName() || getPageName());
	dlPush({
		'event':     'fgWebAnalytics',
		'fgVarType': '',
		'fgVarCat':  `Záložky ${ pageName }`,
		'fgVarAct':  text,
		'fgVarLbl':  text,
		'fgVarTxt':  '',
	});
});

// GA - vyhledani pobocky
$(document).on('submit', '.gmapBranchesForm', (e) => {
	const gmapInputText = $('input[type="text"]', e.target).val();

	dlPush({
		'event':     'fgWebAnalytics',
		'fgVarType': '',
		'fgVarCat':  'Mapa',
		'fgVarAct':  'Vyhledávání',
		'fgVarLbl':  gmapInputText,
		'fgVarTxt':  '',
	});
});

/**
 * LANDING PAGES
 */
$(document).on('FG_UNVEIL_BLOCK_TRIGGER', (e) => {
	const unveilBlock = e.target.closest('.js_gtmChooser');
	if ( unveilBlock && unveilBlock.dataset && unveilBlock.dataset.gtmBlockOrder && unveilBlock.dataset.gtmBlockName ) {

		const varAct = `${ unveilBlock.dataset.gtmBlockOrder }.${ unveilBlock.dataset.gtmBlockName }`;

		dlPush({
			'event':    'fgWebAnalytics',
			'fgVarCat': getLandingPageName(),
			'fgVarAct': varAct,
			'fgVarLbl': window.location.pathname,
		});
	}
});

$(document).on('FG_UNVEIL_SUBMIT_TRIGGER', (e) => {
	const submitBlock = e.target.closest('.js_gtmChooser');
	if ( submitBlock && submitBlock.dataset && submitBlock.dataset.gtmBlockOrder && submitBlock.dataset.gtmBlockName ) {

		const varAct = `${ submitBlock.dataset.gtmBlockOrder }.1 ${ submitBlock.dataset.gtmBlockName } - klik na DALŠÍ`;
		const valuesSelector = submitBlock.querySelector('input').getAttribute('name');
		const selectedValues = Array.from(submitBlock.querySelectorAll(`[name="${ valuesSelector }"]:checked`)).map(el => el.parentNode.querySelector('label').textContent.trim());

		dlPush({
			'event':    'fgWebAnalytics',
			'fgVarCat': getLandingPageName(),
			'fgVarAct': varAct,
			'fgVarLbl': selectedValues,
		});

	}
});

$(document).on('click', '.js_gtmChooserButton', (e) => {
	const button = e.target;
	if ( button ) {
		const btnText = button.textContent.trim();
		dlPush({
			'event':    'fgWebAnalytics',
			'fgVarCat': `Tlačítko ${ getLandingPageName() }`,
			'fgVarAct': btnText,
			'fgVarLbl': btnText,
		});
	}
});

/** ********************************
 *
 * FLEXI RISK
 *
 * ******************************** */

// GA - Flexi Risk - 1. + 2. krok - odeslani CallMeBack
$(document).on('submit', '.hp .js_gtmFlexiRiskStart', function (e) {
	if ( $(e.target).find('.js_gtmWizardWeWillCallYouForm').length > 0 ) {
		const phoneNumber = `${ $('[name="frm.cmbPhone"]', this).val() }`.trim();

		if ( phoneNumber ) {
			dlPush({
				'event':     'fgWebAnalytics',
				'fgVarType': '',
				'fgVarCat':  'Sjednání pojištění Flexi Risk',
				'fgVarAct':  `${ getPageName() } - Zanechání telefonního čísla HP`,
				'fgVarLbl':  phoneNumber,
				'fgVarTxt':  '',
			});
		}
	}
});

// GA - Flexi Risk - 1. krok - zacatek pruvodce - nacteni
$(window).on('load', () => {
	$('.js_gtmFlexiRiskStart').each(function () {
		let startPage;
		const $form = $(this);

		switch ( $form.data('gtmStartPage') ) {
			case 'flexiRiskSnippet':
				startPage = ` - ${ (document.body && document.body.classList.contains('hp')) ?
					'homepage' : (getLandingPageName() || getPageName()) }`;
				break;
			case 'flexiRiskLoad':
				startPage = ' - načtení rozpracované nabídky';
				break;
			case 'basicData':
				startPage = ($('body').hasClass('flexi-risk')) ? ' - detail produktu' : ' - průvodce';
				startPage += ($form.find('.form-control').eq(0).val() === '') ? '' : ' / předvyplněno';
				break;
			case 'callCentrumPin':
				startPage = ' - načtení nabídky z callcentra';
				break;
			default:
				startPage = '';
		}

		dlPush({
			'event':     'fgWebAnalytics',
			'fgVarType': '',
			'fgVarCat':  'Sjednání pojištění Flexi Risk',
			'fgVarAct':  'Začátek formuláře',
			'fgVarLbl':  `Začátek formuláře${ startPage }`,
			'fgVarTxt':  '',
		});
	});
});

// GA - Flexi Risk - 1. krok - zacatek pruvodce - odeslani
$(document).on('submit', '.js_gtmFlexiRiskStart', function (e) {
	let startPage;
	const $form = $(this);

	switch ( $form.data('gtmStartPage') ) {
		case 'flexiRiskSnippet':
			// homepage × detail Flexi životní pojištění
			startPage = ($('body').hasClass('hp')) ? ' - homepage' : ' - životní pojištění';
			break;
		case 'flexiRiskLoad':
			// načtení uložené nabídky
			startPage = ' - načtení rozpracované nabídky';
			break;
		case 'basicData':
			// detail Flexi Risk životní pojištění × Online sjednání
			startPage = ($('body').hasClass('flexi-risk')) ? ' - detail produktu' : ' - průvodce';
			startPage += ($form.find('.form-control').eq(0).val() === '') ? '' : ' / předvyplněno';
			break;
		case 'callCentrumPin':
			// načtení nabídky rozpracované callcentrem
			startPage = ' - načtení nabídky z callcentra';
			break;
		default:
			startPage = '';
	}

	if ( $('body').data('actionPartner') ) {
		dlPush({
			'event':     'fgAstorie',
			'fgVarType': '',
			'fgVarCat':  'Sjednání pojištění Flexi Risk',
			'fgVarAct':  'Spočítat pojištění - Astorie',
			'fgVarLbl':  window.location.toString(),
			'fgVarTxt':  '',
		});
	} else {
		dlPush({
			'event':     'fgWebAnalytics',
			'fgVarType': '',
			'fgVarCat':  'Sjednání pojištění Flexi Risk',
			'fgVarAct':  'Spočítat pojištění',
			'fgVarLbl':  `Spočítat pojištění${ startPage }`,
			'fgVarTxt':  '',
		});
	}
	// pro stranku "Flexi zivotni pojisteni" @tbd potrebuje push poslat znovu
	if ( $form.data('gtmStartPage') === 'flexiRiskSnippet' && !$('body').hasClass('hp') ) {
		dlPush({
			'event':     'fgWebAnalytics',
			'fgVarType': '',
			'fgVarCat':  'Sjednání pojištění Flexi Risk',
			'fgVarAct':  'Spočítat pojištění',
			'fgVarLbl':  'Spočítat pojištění',
			'fgVarTxt':  '',
		});
	}

});

// GA - Flexi Risk - zacatek pruvodce - zanechani tel. cisl @see https://ep.fg.cz/issues/92234
$(document).on('click', '.js_gtmWizardWeWillCallYouForm [type="submit"]', () => {
	const cmbInput = document.querySelector('.js_gtmWizardWeWillCallYouForm [name="frm.cmbPhone"]');
	if ( cmbInput instanceof HTMLInputElement && /\d{9,}/.test(cmbInput.value) ) {
		dlPush({
			'event':    'fgWebAnalytics',
			'fgVarCat': 'Sjednání pojištění Flexi Risk',
			'fgVarAct': 'Průvodce FLEXI RISK - Zanechání telefonního čísla',
			'fgVarLbl': window.location.pathname,
		});
	}
});

$(document).on('click', '.js_gtmWizardCMB', () => {
	const cmbInput = document.querySelector('#weWillCallYouForm [name="frm.wwcyPhone"]');
	if ( cmbInput instanceof HTMLInputElement) {
		dlPush({
			'event':    'fgWebAnalytics',
			'fgVarCat': 'Sjednání pojištění Flexi Risk',
			'fgVarAct': 'Průvodce FLEXI RISK - Zanechání telefonního čísla',
			'fgVarLbl': window.location.pathname,
		});
	}
});

// GA - Flexi Risk - HP callmeback
$(document).on('click', '.js_gtmWizardWeWillCallYouForm [type="submit"]', () => {
	const cmbInput = document.querySelector('.js_gtmWizardWeWillCallYouForm [name="frm.cmbPhone"]');
	if ( cmbInput instanceof HTMLInputElement && /\d{9,}/.test(cmbInput.value) ) {
		dlPush({
			'event':    'fgWebAnalytics',
			'fgVarCat': 'Sjednání pojištění Flexi Risk',
			'fgVarAct': 'Průvodce FLEXI RISK - Zanechání telefonního čísla',
			'fgVarLbl': window.location.pathname,
		});
	}
});

// GA - Flexi Risk - zacatek pruvodce - ulozeni varianty pro AB testovani @see https://ep.fg.cz/issues/87777
$(window).on('load', () => {
	if ( document.querySelectorAll('[name="frm.abt"]').length ) {
		dlPush({
			'event': 'fgABTFlexiRisk',
		});
	}
});

$(window).on('partialUpdateComplete', (e) => {
	try {
		if ( e.detail.settings.submitId === 'modal.callMeBack.submit' &&
			document.querySelectorAll('.js_gtmFlexiAbt .js_gtmInputPhone').length === 0
		) {
			const phoneElm = document.querySelector('.js_gtmFlexiAbt .js_gtmInputPhone');
			if ( !(phoneElm instanceof HTMLInputElement) ) return;
			const phoneNumber = phoneElm.value;
			dlPush({
				'event':    'fgABTest',
				'fgVarCat': 'Sjednání pojištění Flexi Risk',
				'fgVarAct': 'Popup - Zanechání telefonního čísla',
				'fgVarLbl': phoneNumber.trim(),
			});
		}
	} catch ( ex ) {
		clog(ex);
	}
});

// GA - Flexi Risk - 1. + 2. krok - napoveda CallMeBack
$(document).on('click', '.js_gtmWizardWeWillCallYouForm .link', () => {
	dlPush({
		'event':     'fgWebAnalytics',
		'fgVarType': '',
		'fgVarCat':  'Sjednání pojištění Flexi Risk',
		'fgVarAct':  `${ getPageName() } - Zobrazení účelu zpracování čísla`,
		'fgVarLbl':  `${ getPageName() } - Zobrazení účelu zpracování čísla`,
		'fgVarTxt':  '',
	});
});

// GA - Flexi Risk - soubory ke stazeni
$(document).on('click', '.js_gtmFlexiRisk .list-files a', function () {
	const fileName = $(this).text();
	dlPush({
		'event':     'fgWebAnalytics',
		'fgVarType': '',
		'fgVarCat':  'Sjednání pojištění Flexi Risk',
		'fgVarAct':  `${ getPageName() } - Stažení souboru`,
		'fgVarLbl':  fileName,
		'fgVarTxt':  '',
	});
});

// GA - Flexi Risk - napoveda k vybranemu pojisteni
$(document).on('click', '.js_gtmFlexiRisk .selected-insurance .item .help', function () {
	const bundle = $(this).parents('.selected-insurance').find('.title .insurance-name').text();
	const insurance = $(this).parents('.item').find('.label').text();
	// console.log('info box - ' + bundle + ' - ' + insurance);
	dlPush({
		'event':     'fgWebAnalytics',
		'fgVarType': '',
		'fgVarCat':  'Sjednání pojištění Flexi Risk',
		'fgVarAct':  `${ getPageName() } - Nápověda k balíčku`,
		'fgVarLbl':  `info box - ${ bundle } - ${ insurance }`,
		'fgVarTxt':  '',
	});
});

// GA - Flexi Risk - submit CMB formu v zahlavi pruvodce
$(document).on('submit', '.js_gtmFlexiRisk .content form', function (e) {
	const elm = document.activeElement;
	if ( elm && (elm.classList.contains('js_gtmWizardCMB') || elm.id === 'wwcyPhone') ) {
		const phoneNumber = `${ $('#wwcyPhone', this).val() }`.trim();
		dlPush({
			'event':     'fgWebAnalytics',
			'fgVarType': '',
			'fgVarCat':  'Sjednání pojištění Flexi Risk',
			'fgVarAct':  'FLEXI RISK životní pojištění - Zanechání telefonního čísla',
			'fgVarLbl':  phoneNumber,
			'fgVarTxt':  '',
		});
	}
});

// GA - Flexi Risk - ulozeni pruvodce
$(document).on('click', '.js_gtmFlexiRisk .selected-insurance-save #saveFormLink', function () {
	const btnName = $(this).text();
	// console.log('info box - ' + bundle + ' - ' + insurance);
	dlPush({
		'event':     'fgWebAnalytics',
		'fgVarType': '',
		'fgVarCat':  'Sjednání pojištění Flexi Risk',
		'fgVarAct':  `${ getPageName() } - změnit / uložit na později`,
		'fgVarLbl':  btnName,
		'fgVarTxt':  '',
	});
});

// GA - Flexi Risk - ulozeni pruvodce
$(document).on('click', '.js_gtmFlexiRisk .js_gtmToggler', function () {
	let blockTitle = $(this).text();
	if ( $(this).data('gtmLbl') === '@parentHeading' ) {
		blockTitle = $(this)
			.parent()
			.prevAll('.js_gtmConsentInputName')
			.text()
			.trim();
	}
	// console.log('toggleBlock - ' + blockTitle);
	dlPush({
		'event':     'fgWebAnalytics',
		'fgVarType': '',
		'fgVarCat':  'Sjednání pojištění Flexi Risk',
		'fgVarAct':  `${ getPageName() } - Zpracování údajů`,
		'fgVarLbl':  `Rozbalení informací - ${ blockTitle }`,
		'fgVarTxt':  '',
	});
});

// GA - Flexi Risk - zmena balicku pojisteni
$(document).on('click', '.js_gtmFlexiRisk form .js_gtmPackageChange', (e) => {
	const btnName = $(e.target).text();
	dlPush({
		'event':     'fgWebAnalytics',
		'fgVarType': '',
		'fgVarCat':  'Sjednání pojištění Flexi Risk',
		'fgVarAct':  `${ getPageName() } - změnit / uložit na později`,
		'fgVarLbl':  btnName,
		'fgVarTxt':  '',
	});
});

// GA - Flexi Risk - prechod na dalsi (posledni) krok pruvodce
$(document).on('submit', '.js_gtmFlexiRisk form', (e) => {
	const clickedButton = document.activeElement; // TODO PHR - proverit funkcnost v safari, dle SO nemusi fungovat
	if (
		!/(.+?)arrangeForm$/gi.test($(e.target).prop('id')) &&
		clickedButton &&
		(
			clickedButton.getAttribute('name') === 'eventName.next' ||
			clickedButton.getAttribute('name') === 'eventName.finish'
		)
	) {
		dlPush({
			'event':     'fgWebAnalytics',
			'fgVarType': '',
			'fgVarCat':  'Sjednání pojištění Flexi Risk',
			'fgVarAct':  `${ getPageName() } - pokračovat`,
			'fgVarLbl':  'Tlačítko pokračovat',
			'fgVarTxt':  '',
		});
	}
	if (
		!/(.+?)arrangeForm$/gi.test($(e.target).prop('id')) &&
		clickedButton &&
		clickedButton.getAttribute('name') === 'eventName.prev'
	) {
		dlPush({
			'event':     'fgWebAnalytics',
			'fgVarType': '',
			'fgVarCat':  'Sjednání pojištění Flexi Risk',
			'fgVarAct':  `${ getPageName() } - zpět`,
			'fgVarLbl':  'Tlačítko pokračovat',
			'fgVarTxt':  '',
		});
	}
});

// GA - Flexi Risk - pokracovani na nasledujici krok
$(document).on('click', '.js_gtmFlexiRisk #track', (e) => {
	const actualStep = $('h1').text().trim();
	const newStep = $(e.target).text().trim();
	dlPush({
		'event':     'fgWebAnalytics',
		'fgVarType': '',
		'fgVarCat':  'Sjednání pojištění Flexi Risk',
		'fgVarAct':  'Drobečková navigace - klik',
		'fgVarLbl':  `Z ${ actualStep } na ${ newStep }`,
		'fgVarTxt':  '',
	});
});

// GA - Flexi Risk - 1. krok - scroll
$(document).on('click', '.js_gtmFlexiRisk .promo-risk .js_gtmEntry', () => {
	dlPush({
		'event':     'fgWebAnalytics',
		'fgVarType': '',
		'fgVarCat':  'Sjednání pojištění Flexi Risk',
		'fgVarAct':  'Klik na sjednat online (začátek)',
		'fgVarLbl':  'Klik na sjednat online (začátek)',
		'fgVarTxt':  '',
	});
});

// GA - Flexi Risk - 1. krok - zakladni udaje + 1. krok snippet na HP
$(document).on('blur', '.js_gtmFlexiRisk #calculator-wrapper .js_gtmEntryInput, .js_gtmFlexiRiskStart .js_gtmEntryInput', function () {
	const inputName = $(this).prop('placeholder');
	let inputVal = $(this).val().trim() || '';
	if ( $(this).hasClass('hasDatepicker') ) {
		// get value from jQueryUI datepicker
		inputVal = makeDate($(this).datepicker('getDate')) || 'invalid date';
	} else {
		inputVal = $(this).val().trim() || '';
	}

	dlPush({
		'event':     'fgWebAnalytics',
		'fgVarType': '',
		'fgVarCat':  'Sjednání pojištění Flexi Risk',
		'fgVarAct':  inputName,
		'fgVarLbl':  inputVal,
		'fgVarTxt':  '',
	});
});

// GA - Flexi Risk - 1. krok - zakladni udaje / kurak
$(document).on('blur', '.js_gtmFlexiRisk #calculator-wrapper .js_gtmEntryCheckboxInput input, .js_gtmFlexiRiskStart .js_gtmEntryCheckboxInput input', (e) => {
	if ( $(e.target).is(':checked') ) {
		const inputName = $(e.target)
			.parents('.form-group')
			.find('>.control-label')
			.text()
			.trim();
		const inputVal = $(e.target)
			.parents('.input-wrapper')
			.find('>.control-label')
			.text()
			.trim();
		dlPush({
			'event':     'fgWebAnalytics',
			'fgVarType': '',
			'fgVarCat':  'Sjednání pojištění Flexi Risk',
			'fgVarAct':  inputName,
			'fgVarLbl':  inputVal,
			'fgVarTxt':  '',
		});
	}

});

// GA - Flexi Risk - 1. krok - napoveda
$(document).on('click', '.js_gtmFlexiRisk #calculator-wrapper #explanation span', () => {
	dlPush({
		'event':     'fgWebAnalytics',
		'fgVarType': '',
		'fgVarCat':  'Sjednání pojištění Flexi Risk',
		'fgVarAct':  'Proč to potřebujeme vědět',
		'fgVarLbl':  'Proč to potřebujeme vědět',
		'fgVarTxt':  '',
	});
});

// GA - Flexi Risk - 1. krok - odeslani
$(document).on('submit', '.js_gtmFlexiRisk [id$="arrangeForm"]', () => {
	dlPush({
		'event':     'fgWebAnalytics',
		'fgVarType': '',
		'fgVarCat':  'Sjednání pojištění Flexi Risk',
		'fgVarAct':  'Spočítat pojištění',
		'fgVarLbl':  'Spočítat pojištění',
		'fgVarTxt':  '',
	});
});

// GA - Flexi Risk - 2. krok - napoveda k pojisteni
$(document).on('click', '.js_gtmFlexiRisk .list-package .package li .help', function () {
	const bundle = $(this)
		.parents('.package')
		.find('.title')
		.text()
		.trim();
	const insurance = $(this)
		.parents('li')
		.find('.insurance .insurance-name')
		.text()
		.trim();
	// console.log('info ' + bundle + ' - ' + insurance);
	dlPush({
		'event':     'fgWebAnalytics',
		'fgVarType': '',
		'fgVarCat':  'Sjednání pojištění Flexi Risk',
		'fgVarAct':  'Nápověda k balíčku',
		'fgVarLbl':  `info ${ bundle } - ${ insurance }`,
		'fgVarTxt':  '',
	});
});

// GA - Flexi Risk - 2. krok - vyber balicku
$(document).on('click', '.js_gtmFlexiRisk .list-package .package .js_submit', function () {
	const bundle = $(this)
		.parents('.package')
		.find('.title')
		.text()
		.trim();
	dlPush({
		'event':     'fgWebAnalytics',
		'fgVarType': '',
		'fgVarCat':  'Sjednání pojištění Flexi Risk',
		'fgVarAct':  `Sjednat online ${ bundle }`,
		'fgVarLbl':  `Sjednat online ${ bundle }`,
		'fgVarTxt':  '',
	});
});

// GA - Flexi Risk - 2. krok - odeslani call me backu z modalu
$(document).on('click', '.js_gtmFlexiRisk .modal--callMeBack .js_gtmSubmit', () => {
	document.addEventListener('partialUpdateComplete', ({ detail: { hasError } }) => {
		if (!hasError) {
			dlPush({
				'event': 'fgWebAnalytics',
				'fgVarCat': 'Sjednání pojištění Flexi Risk',
				'fgVarAct': 'Úspěšné odeslání telefoního čísla z callMeBack okna',
				'fgVarLbl': window.location.toString(),
			});
		}
	}, { once:true });
});

// GA - Flexi Risk - 2. krok - zavření call me backu přes tlačítko
$(document).on('click', '.js_gtmFlexiRisk .modal--callMeBack .js_gtmCloseBtn', (e) => {
	const btnName = e.target.textContent;
	dlPush({
		'event': 'fgWebAnalytics',
		'fgVarCat': 'Sjednání pojištění Flexi Risk',
		'fgVarAct': `Zavření callMeBack okna přes tlačítko - ${ btnName }`,
		'fgVarLbl': window.location.toString(),
	});
});

// GA - Flexi Risk - 2. krok - zavření call me backu přes křížek
$(document).on('click', '.js_gtmFlexiRisk .modal--callMeBack .js_gtmCloseModal', (e) => {
	const btnName = e.target.textContent;
	dlPush({
		'event': 'fgWebAnalytics',
		'fgVarCat': 'Sjednání pojištění Flexi Risk',
		'fgVarAct': 'Zavření callMeBack okna přes křížek',
		'fgVarLbl': window.location.toString(),
	});
});

// GA - Flexi Risk - 3. krok - otazky ve zdravotnim dotazniku
$(document).on('click', '.js_gtmFlexiRisk .health-questionnaire label.control-label', function () {
	const questionLimit = 160;
	const answer = $(this).text();
	let question = $(this)
		.parents('.form-group')
		.find('.control-label--question')
		.text()
		.trim();
	if ( question.length > questionLimit ) question = `${ question.substr(0, questionLimit) }...`;
	dlPush({
		'event':     'fgWebAnalytics',
		'fgVarType': '',
		'fgVarCat':  'Sjednání pojištění Flexi Risk',
		'fgVarAct':  `${ getPageName() } - Odpověď v dotazníku`,
		'fgVarLbl':  `${ question } - ${ answer }`,
		'fgVarTxt':  '',
	});
});

// GA - Flexi Risk - 4. krok - osobni udaje (checkboxy se souhlasy)
$(document).on('click', '.js_gtmFlexiRisk .js_formStep-aboutYou .js_gtmConsentInput', (e) => {
	const _et = e.target;
	// `click` se duplikuje pro `label` a pro `input`, bereme pouze udalost z `inputu`
	if ( _et.tagName.toLowerCase() === 'input' ) {
		const inputName = $(_et)
			.parents('.form-group')
			.find('.js_gtmConsentInputName')
			.text()
			.trim();
		let inputVal = '';

		if ( _et.getAttribute('type').toLowerCase() === 'radio') {
			console.log('is radio');
			inputVal = $(_et).next('.control-label').text().trim();
		}

		if ( _et.getAttribute('type').toLowerCase() === 'checkbox') {
			console.log('is checkbox');
			inputVal = $(_et).is(':checked') ? 'ano' : 'ne';
		}

		if ( !$(e.target).is(':disabled') ) {
			dlPush({
				'event':     'fgWebAnalytics',
				'fgVarType': '',
				'fgVarCat':  'Sjednání pojištění Flexi Risk',
				'fgVarAct':  `${ getPageName() } - ${ inputName }`,
				'fgVarLbl':  inputVal,
				'fgVarTxt':  '',
			});
		}
	}
});


// GA - Flexi Risk - 5. krok - bydliste (kontaktni adresa)
$(document).on('click', '.js_gtmFlexiRisk .js_formStep-residencePayment .js_gtmCheckboxInput', function (e) {
	// `click` se duplikuje pro `label` a pro `input`, bereme pouze udalost z `inputu`
	if ( e.target.tagName.toLowerCase() === 'input' ) {
		const inputName = $(this).find('.control-label').text().trim();
		const inputVal = $(this).find('[type="checkbox"]').is(':checked') ? 'ano' : 'ne';
		dlPush({
			'event':     'fgWebAnalytics',
			'fgVarType': '',
			'fgVarCat':  'Sjednání pojištění Flexi Risk',
			'fgVarAct':  `${ getPageName() } - ${ inputName }`,
			'fgVarLbl':  inputVal,
			'fgVarTxt':  '',
		});
	}
});

// GA - Flexi Risk - 6. krok - rekapitulace (zmena udaju)
$(document).on('click', '.js_gtmFlexiRisk .js_formStep-recap .js_gtmBtnChange', function () {
	const section = $(this).parents('.list-summary-part').prop('id').trim();
	dlPush({
		'event':     'fgWebAnalytics',
		'fgVarType': '',
		'fgVarCat':  'Sjednání pojištění Flexi Risk',
		'fgVarAct':  'Shrnutí objednávky',
		'fgVarLbl':  `Změnit údaje - ${ section }`,
		'fgVarTxt':  '',
	});
});

// GA - Flexi Risk - 6. krok - rekapitulace (zaverecny souhlas)
$(document).on('click', '.js_gtmFlexiRisk .js_formStep-recap .js_gtmFinalProvisions input', (e) => {
	const inputName = $(e.target)
		.parents('.form-group')
		.find('label')
		.text()
		.trim();
	const inputVal = $(e.target).is(':checked') ? 'ano' : 'ne';
	dlPush({
		'event':     'fgWebAnalytics',
		'fgVarType': '',
		'fgVarCat':  'Sjednání pojištění Flexi Risk',
		'fgVarAct':  `${ getPageName() } - ${ inputName }`,
		'fgVarLbl':  inputVal,
		'fgVarTxt':  '',
	});
});

// GA - Flexi Risk - 4. krok + 5. krok - osobni udaje / bydliste a platba - osobni udaje (udaje po kliku)
$(document).on('click', '.js_gtmFlexiRisk #formWrapper .js_gtmClickInput', (e) => {
	// `click` se duplikuje pro `label` a pro `input`, bereme pouze udalost z `inputu`
	if ( e.target.tagName.toLowerCase() === 'input' ) {
		const inputName = $(e.target)
			.parents('.form-group')
			.find('> .control-label')
			.text()
			.trim();
		const inputVal = $(e.target)
			.parent('.input-wrapper')
			.find('label')
			.text()
			.trim();
		dlPush({
			'event':     'fgWebAnalytics',
			'fgVarType': '',
			'fgVarCat':  'Sjednání pojištění Flexi Risk',
			'fgVarAct':  `${ getPageName() } - ${ inputName }`,
			'fgVarLbl':  inputVal,
			'fgVarTxt':  '',
		});
	}
});

// GA - Flexi Risk - 4. krok + 5. krok - osobni udaje / bydliste a platba (udaje po opusteni pole)
$(document).on('blur', '.js_gtmFlexiRisk #formWrapper .js_gtmBlurInput', (e) => {
	const inputName = $(e.target)
		.parents('.form-group')
		.find('> .control-label')
		.text()
		.trim();
	let inputVal;
	if ( e.target.tagName.toLowerCase() === 'select' ) {
		inputVal = $('option:selected', e.target).text();
	} else {
		inputVal = $(e.target).val().trim();
	}
	// console.log('blur > ' + inputName + ': ' + inputVal);
	dlPush({
		'event':     'fgWebAnalytics',
		'fgVarType': '',
		'fgVarCat':  'Sjednání pojištění Flexi Risk',
		'fgVarAct':  `${ getPageName() } - ${ inputName }`,
		'fgVarLbl':  inputVal,
		'fgVarTxt':  '',
	});
});

// GA - Flexi Risk - 4. krok + 5. krok - osobni udaje / bydliste a platba (naseptavac)
$(document).on('typeahead:select', '.js_gtmFlexiRisk #formWrapper', (e) => {
	const inputName = $(e.target)
		.parents('.form-group')
		.find('> .control-label')
		.text()
		.trim();
	const inputVal = $(e.target).val();
	dlPush({
		'event':     'fgWebAnalytics',
		'fgVarType': '',
		'fgVarCat':  'Sjednání pojištění Flexi Risk',
		'fgVarAct':  `${ getPageName() } - ${ inputName }`,
		'fgVarLbl':  inputVal,
		'fgVarTxt':  '',
	});
});

// GA - Flexi Risk - Odkloneni na CC - load
$(window).on('load', () => {
	if ( $('body').hasClass('js_gtmFlexiCallCentrum') ) {
		dlPush({
			'event':     'fgWebAnalytics',
			'fgVarType': '',
			'fgVarCat':  'Sjednání pojištění Flexi Risk',
			'fgVarAct':  'Odklonění na Call Centrum',
			'fgVarLbl':  'Odklonění na Call Centrum',
			'fgVarTxt':  '',
		});
	}
});

// GA - Flexi Risk - odklon na CC / odeslani CallMeBack
$(document).on('submit', '.js_gtmFlexiCallCentrum .js_gtmFlexiCallMeBackForm', function () {
	const phoneNumber = $('#phone', this).val().trim();
	dlPush({
		'event':     'fgWebAnalytics',
		'fgVarType': '',
		'fgVarCat':  'Sjednání pojištění Flexi Risk',
		'fgVarAct':  `${ getPageName() } - Zanechání telefonního čísla`,
		'fgVarLbl':  phoneNumber,
		'fgVarTxt':  '',
	});
});

// GA - Flexi Risk - odklon na CC / napoveda CallMeBack
$(document).on('click', '.js_gtmFlexiCallCentrum .js_gtmFlexiCallMeBackForm .link', () => {
	dlPush({
		'event':     'fgWebAnalytics',
		'fgVarType': '',
		'fgVarCat':  'Sjednání pojištění Flexi Risk',
		'fgVarAct':  `${ getPageName() } - Zobrazení účelu zpracování čísla`,
		'fgVarLbl':  `${ getPageName() } - Zobrazení účelu zpracování čísla`,
		'fgVarTxt':  '',
	});
});

$(window).on('load', () => {
	if ( $('body').hasClass('js_gtmFlexiRisk') && document.querySelector('.satisfaction') ) {
		const price = document.querySelector(fragments.PRICE).innerHTML;
		dlPush({
			'event':     'fgWebAnalytics',
			'fgVarCat':  'Sjednání pojištění Flexi Risk',
			'fgVarAct':  'Sjednání pojištění – Děkujeme',
			'fgVarLbl':  `${ getPageName() }`,
			'fgVarRevenue': `${ price }`,
		});
	}
});



// WEBPACK FOOTER //
// ./config/fe/web-default/src/js/web/jquery.fgAnalytics.js